
(()=>{
'use strict';

const normal=[
 ['Schwarz','gp-floor-pace-leiste-schwarz-4x-zwischenleiste'],
 ['Grau','gp-floor-pace-leiste-grau-4x-zwischenleiste'],
 ['Hellgrau','gp-floor-pace-leiste-hellgrau-4x-zwischenleiste'],
 ['Weiß','gp-floor-pace-leiste-weiss-4x-zwischenleiste'],
 ['Hellblau','gp-floor-pace-leiste-ocean-hellblau-4x-zwischenleiste'],
 ['Blau','gp-floor-pace-leiste-blau-4x-zwischenleiste'],
 ['Ocean Blau','gp-floor-pace-leiste-ocean-blau-4x-zwischenleiste'],
 ['Türkis','gp-floor-pace-leiste-turkis-4x-zwischenleiste'],
 ['Ocean Mint','gp-floor-pace-leiste-ocean-mint-4x-zwischenleiste'],
 ['Grün','gp-floor-pace-leiste-grun-4x-zwischenleiste'],
 ['Hellgrün','gp-floor-pace-leiste-hellgrun-4x-zwischenleiste'],
 ['Orange','gp-floor-pace-leiste-orange-4x-zwischenleiste'],
 ['Rot','gp-floor-pace-leiste-rot-4x-zwischenleiste'],
 ['Lila','gp-floor-pace-leiste-lila-4x-zwischenleiste'],
 ['Pink','gp-floor-pace-leiste-pink-4x-zwischenleiste'],
 ['Ocean Olive','gp-floor-pace-leiste-ocean-olive-4x-zwischenleiste'],
 ['Ocean Braun','gp-floor-pace-leiste-ocean-braun-4x-zwischenleiste']
];

// Reihenfolge und Produkt-Handles exakt nach Vorgabe.
const ledColors=[
 ['Schwarz','gp-floor-pace-led-profil-schwarz','gp-floor-pace-led-profil-rot-umrandung','#222222'],
 ['Grau','gp-floor-pace-led-profil-grau','gp-floor-pace-led-profil-grau-umrandung','#777777'],
 ['Oceanblau','gp-floor-pace-led-profil-oceanblau','gp-floor-pace-led-profil-oceanblau-umrandung','#257e9b'],
 ['Blau','gp-floor-pace-led-profil-blau','gp-floor-pace-led-profil-blau-umrandung','#267ac2'],
 ['Rot','gp-floor-pace-led-profil-rot','gp-floor-pace-led-profil-rot-umrandung-1','#b82b31'],
 ['Grün','gp-floor-pace-led-profil-grun','gp-floor-pace-led-profil-grun-umrandung','#2f8153'],
 ['Olive','gp-floor-pace-led-profil-olive','gp-floor-pace-led-profil-olive-umrandung','#747e4b']
];

const cache=new Map();

async function getProduct(handle){
 if(!handle)return null;
 if(!cache.has(handle)){
  cache.set(handle,
   fetch('/products/'+encodeURIComponent(handle)+'.js')
   .then(r=>{
    if(!r.ok)throw Error('Produkt '+handle+' nicht erreichbar');
    return r.json();
   })
   .catch(e=>{
    cache.delete(handle);
    throw e;
   })
  );
 }
 return cache.get(handle);
}

function imageAt(p,i){
 if(!p)return '';
 const im=p.images?.[i];
 return typeof im==='string'
  ? im
  : (im?.src||(i===0?p.featured_image:'')||'');
}

function init(root){
 if(root.dataset.gplInit)return;
 root.dataset.gplInit='1';

 const q=s=>root.querySelector(s);
 const qa=s=>[...root.querySelectorAll(s)];

 let mode='lines',
     led='Schwarz',
     finish='Silverline',
     color='Schwarz',
     showAllNormal=false,
     planData=null,
     lastFocus=null,
     locked=false;

 const overlay=q('[data-overlay]');
 if(!overlay)return;

 function open(){
  lastFocus=document.activeElement;
  overlay.hidden=false;
  document.body.style.overflow='hidden';
  q('[data-close]').focus();
  refresh();
 }

 function close(){
  overlay.hidden=true;
  document.body.style.overflow='';
  lastFocus?.focus();
 }

 q('[data-open]').addEventListener('click',open);

 qa('[data-close]').forEach(b=>
  b.addEventListener('click',close)
 );

 overlay.addEventListener('click',e=>{
  if(e.target===overlay)close();
 });

 document.addEventListener('keydown',e=>{
  if(overlay.hidden)return;

  if(e.key==='Escape')close();

  if(e.key==='Tab'){
   const nodes=qa(
    '.gpl-modal button:not([disabled]),.gpl-modal input,.gpl-modal a'
   ).filter(n=>n.offsetParent!==null);

   if(!nodes.length)return;

   const first=nodes[0];
   const last=nodes[nodes.length-1];

   if(e.shiftKey&&document.activeElement===first){
    e.preventDefault();
    last.focus();
   }else if(!e.shiftKey&&document.activeElement===last){
    e.preventDefault();
    first.focus();
   }
  }
 });

 qa('[data-mode]').forEach(b=>
  b.addEventListener('click',()=>{
   mode=b.dataset.mode;

   qa('[data-mode]').forEach(x=>
    x.classList.toggle('is-active',x===b)
   );

   qa('[data-lines]').forEach(x=>
    x.hidden=mode!=='lines'
   );

   qa('[data-border]').forEach(x=>
    x.hidden=mode!=='border'
   );

   renderLed();
   refresh();
  })
 );

 qa('[data-finish]').forEach(b=>
  b.addEventListener('click',()=>{
   finish=b.dataset.finish;

   qa('[data-finish]').forEach(x=>
    x.classList.toggle('is-active',x===b)
   );

   refresh();
  })
 );

 qa('[data-field]').forEach(i=>
  i.addEventListener('input',refresh)
 );

 // Farbkachel mit Produkt-Info-Symbol
 function tile(name,selected,src,swatch,click,handle){
  const wrap=document.createElement('div');
  wrap.className='gpl-choice-wrap';

  const b=document.createElement('button');
  b.type='button';
  b.className='gpl-color'+(selected?' is-active':'');

  if(src){
   const img=document.createElement('img');
   img.alt=name;
   img.loading='lazy';
   img.src=src;

   img.addEventListener('error',()=>{
    img.remove();
    const x=document.createElement('div');
    x.className='gpl-placeholder';
    x.style.background=swatch||'#343434';
    x.textContent='✧';
    b.prepend(x);
   });

   b.append(img);
  }else{
   const x=document.createElement('div');
   x.className='gpl-placeholder';
   x.style.background=swatch||'#343434';
   x.textContent='✧';
   b.append(x);
  }

  const label=document.createElement('span');
  label.textContent=name;
  b.append(label);

  b.addEventListener('click',click);
  wrap.append(b);

  if(handle){
   const info=document.createElement('a');
   info.className='gpl-choice-info';
   info.href='/products/'+encodeURIComponent(handle);
   info.target='_blank';
   info.rel='noopener noreferrer';
   info.textContent='!';
   info.title='Produktdetails ansehen';
   info.setAttribute(
    'aria-label',
    'Produktdetails zu '+name+' ansehen'
   );
   wrap.append(info);
  }

  return wrap;
 }

 // LED-Leistenfarben in gewünschter Reihenfolge
 function renderLed(){
  const box=q('[data-led-choice]');
  box.replaceChildren();

  for(const [name,lineHandle,borderHandle,swatch] of ledColors){
   const handle=mode==='lines'?lineHandle:borderHandle;

   const wrap=tile(
    name,
    name===led,
    '',
    swatch,
    ()=>{
     led=name;
     renderLed();
     refresh();
    },
    handle
   );

   box.append(wrap);

   getProduct(handle).then(p=>{
    const src=imageAt(p,2)||imageAt(p,0);

    if(src){
     const ph=wrap.querySelector('.gpl-placeholder');

     if(ph){
      const img=document.createElement('img');
      img.src=src;
      img.alt=name;
      img.loading='lazy';
      ph.replaceWith(img);
     }
    }
   }).catch(()=>{});
  }
 }

 // Normale Zwischenleisten
 function renderNormal(){
  const box=q('[data-normal-choice]');
  box.replaceChildren();

  const chosen=showAllNormal?normal:normal.slice(0,6);

  for(const [name,handle] of chosen){
   const wrap=tile(
    name,
    name===color,
    '',
    '#393939',
    ()=>{
     color=name;
     renderNormal();
     refresh();
    },
    handle
   );

   box.append(wrap);

   getProduct(handle).then(p=>{
    const src=imageAt(p,0);

    if(src){
     const img=document.createElement('img');
     img.src=src;
     img.alt=name;
     img.loading='lazy';

     wrap.querySelector('.gpl-placeholder')?.replaceWith(img);
    }
   }).catch(()=>{});
  }

  if(!showAllNormal){
   const b=document.createElement('button');
   b.type='button';
   b.className='gpl-color gpl-more';
   b.innerHTML='<b>＋</b><span>Alle Farben</span>';

   b.addEventListener('click',()=>{
    showAllNormal=true;
    renderNormal();
   });

   box.append(b);
  }
 }

 function distribute(total,size,num){
  if(size*num>total)return null;

  const free=total-size*num;

  return Array.from(
   {length:num},
   (_,i)=>Math.round(
    free*(i+1)/(num+1)+i*size
   )
  );
 }

 // Profile: 200, 160, 80 und 40 cm
 function combo(tiles){
  const result=[];

  for(const t of [5,4,2,1]){
   const quantity=Math.floor(tiles/t);

   if(quantity){
    result.push({
     tiles:t,
     qty:quantity
    });
   }

   tiles%=t;
  }

  return result;
 }

 function calculate(){
  const f=k=>Number(q('[data-field="'+k+'"]').value);

  const gw=f('gw');
  const gd=f('gd');

  const n=Math.ceil(gw/40);
  const m=Math.ceil(gd/40);

  if(![gw,gd].every(v=>Number.isFinite(v)&&v>0)){
   throw Error(
    'Bitte gültige Garagenmaße in Zentimetern eingeben.'
   );
  }

  if(n<2||m<2){
   throw Error(
    'Die Garage muss mindestens 80 cm breit und tief sein.'
   );
  }

  if(n*m>10000){
   throw Error('Garagenfläche zu groß für die Skizze.');
  }

  if(mode==='lines'){
   const count=f('count');

   if(!Number.isInteger(count)||count<1||count>=n){
    throw Error(
     'LED-Linien: Bitte eine Anzahl zwischen 1 und '+
     (n-1)+' wählen.'
    );
   }

   const lines=distribute(n-1,1,count).map(x=>x+1);

   return{
    mode,
    n,
    m,
    lines,
    items:combo(m).map(i=>({
     ...i,
     qty:i.qty*count
    })),
    normalCount:0,
    normalPacks:0
   };
  }

  const bx=f('bx');
  const by=f('by');

  const w=6;
  const h=14;

  if(![bx,by].every(v=>
   Number.isInteger(v)&&v>=1&&v<=10
  )){
   throw Error(
    'Stellplatzzahlen müssen zwischen 1 und 10 liegen.'
   );
  }

  if(bx*w>n||by*h>m){
   throw Error(
    'Die Umrandungs-Sets passen nicht in die Garage.'
   );
  }

  const xs=distribute(n,w,bx);
  const ys=distribute(m,h,by);

  const rects=[];
  const vLines=new Set();
  const hLines=new Set();
  const ledV=new Set();
  const ledH=new Set();

  for(const x of xs){
   for(const y of ys){
    rects.push({x,y});

    for(const xx of [x,x+w]){
     vLines.add(xx);

     for(let k=y;k<y+h;k++){
      ledV.add(xx+','+k);
     }
    }

    for(const yy of [y,y+h]){
     hLines.add(yy);

     for(let k=x;k<x+w;k++){
      ledH.add(k+','+yy);
     }
    }
   }
  }

  const nv=[];
  const nh=[];

  for(const x of vLines){
   for(let y=0;y<m;y++){
    if(!ledV.has(x+','+y)){
     nv.push([x,y]);
    }
   }
  }

  for(const y of hLines){
   for(let x=0;x<n;x++){
    if(!ledH.has(x+','+y)){
     nh.push([x,y]);
    }
   }
  }

  const normalCount=nv.length+nh.length;

  return{
   mode,
   n,
   m,
   rects,
   nv,
   nh,
   normalCount,
   normalPacks:Math.ceil(normalCount/4),
   sets:rects.length
  };
 }

 function sketch(p){
  const ns='http://www.w3.org/2000/svg';
  const unit=Math.min(24,550/Math.max(p.n,p.m));
  const pad=26;

  const svg=document.createElementNS(ns,'svg');

  svg.setAttribute(
   'viewBox',
   `0 0 ${p.n*unit+pad*2} ${p.m*unit+pad*2}`
  );

  svg.setAttribute('role','img');
  svg.setAttribute('aria-label','LED-Garagenplan');

  function line(x1,y1,x2,y2,c,w){
   const l=document.createElementNS(ns,'line');

   for(const [k,v] of Object.entries({
    x1:pad+x1*unit,
    y1:pad+y1*unit,
    x2:pad+x2*unit,
    y2:pad+y2*unit,
    stroke:c,
    'stroke-width':w,
    'stroke-linecap':'square'
   })){
    l.setAttribute(k,v);
   }

   svg.append(l);
  }

  for(let x=0;x<=p.n;x++){
   line(x,0,x,p.m,'#444',.65);
  }

  for(let y=0;y<=p.m;y++){
   line(0,y,p.n,y,'#444',.65);
  }

  if(p.mode==='lines'){
   for(const x of p.lines){
    line(
     x,0,x,p.m,
     '#f05050',
     Math.max(3,unit*.16)
    );
   }
  }else{
   for(const [x,y] of p.nv){
    line(
     x,y,x,y+1,
     '#d8d8d8',
     Math.max(3,unit*.16)
    );
   }

   for(const [x,y] of p.nh){
    line(
     x,y,x+1,y,
     '#d8d8d8',
     Math.max(3,unit*.16)
    );
   }

   for(const {x,y} of p.rects){
    line(x,y,x+6,y,'#f05050',Math.max(3,unit*.16));
    line(x,y+14,x+6,y+14,'#f05050',Math.max(3,unit*.16));
    line(x,y,x,y+14,'#f05050',Math.max(3,unit*.16));
    line(x+6,y,x+6,y+14,'#f05050',Math.max(3,unit*.16));
   }
  }

  line(0,0,p.n,0,'#888',1.4);
  line(0,0,0,p.m,'#888',1.4);
  line(p.n,0,p.n,p.m,'#888',1.4);
  line(0,p.m,p.n,p.m,'#888',1.4);

  q('[data-sketch]').replaceChildren(svg);
 }

 // Artikelübersicht mit Info-Link
 function itemRow(name,desc,qty,img,handle){
  const row=document.createElement('div');
  row.className='gpl-item';

  const pic=document.createElement('img');
  pic.alt=name;
  pic.loading='lazy';

  if(img){
   pic.src=img;
  }else{
   pic.style.background='#444';
   pic.alt='Produktbild folgt';
  }

  const body=document.createElement('div');
  body.className='gpl-item-main';

  const title=document.createElement('strong');
  title.textContent=name;

  const detail=document.createElement('small');
  detail.textContent=desc;

  body.append(title,detail);

  const amount=document.createElement('span');
  amount.className='gpl-item-qty';
  amount.textContent=qty+' ×';

  row.append(pic,body,amount);

  if(handle){
   const info=document.createElement('a');
   info.className='gpl-item-info';
   info.href='/products/'+encodeURIComponent(handle);
   info.target='_blank';
   info.rel='noopener noreferrer';
   info.textContent='!';
   info.title='Produktdetails ansehen';

   info.setAttribute(
    'aria-label',
    'Weitere Informationen zu '+name
   );

   row.append(info);
  }

  q('[data-results]').append(row);
  return row;
 }

 async function renderItems(p){
  const box=q('[data-results]');
  box.replaceChildren();

  const selected=ledColors.find(c=>c[0]===led);

  if(p.mode==='lines'){
   const rows=p.items.map(i=>({
    i,
    row:itemRow(
     'LED-Profil '+led,
     i.tiles*40+' cm ('+i.tiles+' '+
     (i.tiles===1?'Leiste':'Leisten')+
     ') · '+finish+' · Komplettset',
     i.qty,
     '',
     selected?.[1]
    )
   }));

   try{
    const product=await getProduct(selected?.[1]);
    if(p!==planData)return;

    for(const {row} of rows){
     const img=row.querySelector('img');
     img.src=imageAt(product,0)||'';
    }
   }catch{}
  }else{
   const borderRow=itemRow(
    'LED-Umrandung '+led,
    '240 × 560 cm · '+finish+' · Komplettset',
    p.sets,
    '',
    selected?.[2]
   );

   getProduct(selected?.[2]).then(prod=>{
    if(p===planData){
     borderRow.querySelector('img').src=
      imageAt(prod,0)||'';
    }
   }).catch(()=>{});

   if(p.normalPacks){
    const normalHandle=normal.find(x=>x[0]===color)?.[1];

    const normalRow=itemRow(
     'Zwischenleisten '+color,
     '4 Stück je Packung · '+
     p.normalCount+' Stück benötigt',
     p.normalPacks,
     '',
     normalHandle
    );

    getProduct(normalHandle).then(prod=>{
     if(p===planData){
      normalRow.querySelector('img').src=
       imageAt(prod,0)||'';
     }
    }).catch(()=>{});
   }
  }

  q('[data-total]').textContent=
   p.mode==='lines'
    ? p.items.reduce((a,b)=>a+b.qty,0)+' Sets'
    : p.sets+' Sets · '+p.normalPacks+' Packungen';
 }

 function refresh(){
  q('[data-error]').hidden=true;
  q('[data-cart-status]').textContent='';

  try{
   planData=calculate();
   sketch(planData);
   renderItems(planData);
   q('[data-add]').disabled=false;
  }catch(e){
   planData=null;
   q('[data-error]').textContent=e.message;
   q('[data-error]').hidden=false;
   q('[data-sketch]').replaceChildren();
   q('[data-results]').replaceChildren();
   q('[data-add]').disabled=true;
  }
 }

 // Neue Variantenbezeichnungen:
 // 40 cm (1 Leisten)
 // 80 cm (2 Leisten)
 // 160 cm (4 Leisten)
 // 200 cm (5 Leisten)
 function chooseVariant(product,tiles){
  const cm=tiles*40;

  const byLength=product.variants.filter(v=>
   new RegExp(
    '(^|\\D)'+cm+'\\s*cm(\\D|$)','i'
   ).test(
    [v.title,...(v.options||[])].join(' ')
   )
  );

  if(!byLength.length){
   throw Error(
    'Die Variante '+cm+' cm ('+
    tiles+' Leisten) ist nicht angelegt.'
   );
  }

  const matched=byLength.filter(v=>
   [v.title,...(v.options||[])]
    .join(' ')
    .toLowerCase()
    .includes(finish.toLowerCase())
  );

  if(matched.length!==1){
   throw Error(
    'Die Kombination '+cm+' cm / '+
    finish+' ist nicht eindeutig angelegt.'
   );
  }

  if(!matched[0].available){
   throw Error(
    cm+' cm / '+finish+' ist ausverkauft.'
   );
  }

  return matched[0];
 }

 function chooseBorderVariant(product){
  const found=product.variants.filter(v=>
   [v.title,...(v.options||[])]
    .join(' ')
    .toLowerCase()
    .includes(finish.toLowerCase())
  );

  if(found.length!==1){
   throw Error(
    'Die Variante '+finish+
    ' ist beim Umrandungs-Set noch nicht eindeutig angelegt.'
   );
  }

  if(!found[0].available){
   throw Error(
    'Umrandungs-Set '+finish+' ist ausverkauft.'
   );
  }

  return found[0];
 }

 // Warenkorb
 q('[data-add]').addEventListener('click',async()=>{
  if(!planData||locked)return;

  locked=true;
  q('[data-add]').disabled=true;

  q('[data-cart-status]').textContent=
   'Produkte werden geprüft …';

  try{
   const p=planData;
   const selected=ledColors.find(c=>c[0]===led);

   const handle=p.mode==='lines'
    ?selected?.[1]
    :selected?.[2];

   if(!handle){
    throw Error(
     'Diese LED-Farbe ist noch nicht als Produkt verfügbar.'
    );
   }

   const product=await getProduct(handle);
   const items=[];

   if(p.mode==='lines'){
    for(const entry of p.items){
     items.push({
      id:chooseVariant(product,entry.tiles).id,
      quantity:entry.qty
     });
    }
   }else{
    items.push({
     id:chooseBorderVariant(product).id,
     quantity:p.sets
    });

    if(p.normalPacks){
     const handleNormal=normal.find(x=>x[0]===color)?.[1];
     const np=await getProduct(handleNormal);

     if(np.variants.length!==1){
      throw Error(
       'Zwischenleisten-Variante bitte prüfen.'
      );
     }

     if(!np.variants[0].available){
      throw Error(
       'Gewählte Zwischenleisten sind nicht verfügbar.'
      );
     }

     items.push({
      id:np.variants[0].id,
      quantity:p.normalPacks
     });
    }
   }

   if(p!==planData){
    throw Error(
     'Die Auswahl wurde verändert. Bitte erneut versuchen.'
    );
   }

   const base=window.Shopify?.routes?.root||'/';

   const response=await fetch(base+'cart/add.js',{
    method:'POST',
    headers:{
     'Content-Type':'application/json'
    },
    body:JSON.stringify({items})
   });

   if(!response.ok){
    const error=await response.json().catch(()=>({}));

    throw Error(
     error.description||
     error.message||
     'Warenkorb konnte nicht aktualisiert werden.'
    );
   }

   window.location.href=base+'cart';

  }catch(e){
   q('[data-cart-status]').textContent=e.message;
   q('[data-add]').disabled=false;
  }finally{
   locked=false;
  }
 });

 // Skizze speichern
 q('[data-save]').addEventListener('click',()=>{
  const svg=q('[data-sketch] svg');
  if(!svg)return;

  const xml=new XMLSerializer().serializeToString(svg);

  const blob=new Blob([xml],{
   type:'image/svg+xml;charset=utf-8'
  });

  const url=URL.createObjectURL(blob);
  const a=document.createElement('a');

  a.href=url;
  a.download='garage-parts-led-skizze.svg';

  document.body.append(a);
  a.click();
  a.remove();

  setTimeout(()=>URL.revokeObjectURL(url),1000);
 });

 // Skizze drucken
 q('[data-print]').addEventListener('click',()=>{
  const svg=q('[data-sketch] svg');
  if(!svg)return;

  const win=window.open('','_blank');

  if(!win){
   q('[data-cart-status]').textContent=
    'Bitte Pop-ups zum Drucken erlauben.';
   return;
  }

  const html=
   '<!doctype html><html><head>'+
   '<meta charset="utf-8">'+
   '<title>Garage Parts LED-Plan</title>'+
   '<style>'+
   'body{font:16px Arial;padding:30px;color:#111}'+
   'svg{width:100%;max-height:70vh}'+
   'h1{font-size:22px}'+
   '</style></head><body>'+
   '<h1>Garage Parts – LED-Bodenplan</h1>'+
   '<p>'+
   (mode==='lines'
    ?'Durchgehende LED-Linien'
    :'Fahrzeugumrandung')+
   ' · '+led+' · '+finish+
   '</p>'+
   new XMLSerializer().serializeToString(svg)+
   '</body></html>';

  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();

  win.addEventListener(
   'load',
   ()=>win.print(),
   {once:true}
  );
 });

 renderLed();
 renderNormal();
 refresh();
}

function initAll(){
 document.querySelectorAll('[data-gp-led-planner]').forEach(init);
}

if(document.readyState==='loading'){
 document.addEventListener('DOMContentLoaded',initAll);
}else{
 initAll();
}

document.addEventListener('shopify:section:load',initAll);

})();
